import { render, staticRenderFns } from "./AddClientDialog.vue?vue&type=template&id=5230a28d"
import script from "./AddClientDialog.vue?vue&type=script&lang=js"
export * from "./AddClientDialog.vue?vue&type=script&lang=js"
import style0 from "./AddClientDialog.vue?vue&type=style&index=0&id=5230a28d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports